import { listenToAssetStatuses, type AssetStatusItem } from 'packages/services/assetsService';
import type { SseSubscribeOptions } from '../useSseSubscribe';

type Params = {
    assetIds: string[];
    onMessage: SseSubscribeOptions<AssetStatusItem[]>['onMessage'];
};

export function sseAssetsStatusOptions({ assetIds, onMessage }: Params): SseSubscribeOptions<AssetStatusItem[]> {
    return {
        deps: assetIds,
        subscribe: (onData, onClose) => listenToAssetStatuses(assetIds, onData, onClose),
        onMessage,
    };
}
